import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import heroMockup from "../assets/hero-mockup.png"

export default function Hero() {
  return (
    <section className="relative min-h-[95vh] flex items-center bg-slate-50 overflow-hidden">

      {/* Premium Directional Glow */}
      <div className="absolute -top-40 -left-40 w-[500px] h-[500px] bg-gradient-to-br from-blue-400/20 to-transparent rounded-full blur-3xl"></div>
      <div className="absolute -bottom-40 -right-40 w-[500px] h-[500px] bg-gradient-to-tr from-blue-200/30 to-transparent rounded-full blur-3xl"></div>

      <div className="relative max-w-7xl mx-auto px-6 md:px-12 grid md:grid-cols-2 gap-20 items-center py-40">

        {/* LEFT CONTENT */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="space-y-10"
        >
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="text-sm uppercase tracking-widest text-blue-600 font-semibold"
          >
            Backend Engineer · System Architecture · Performance Optimization
          </motion.p>

          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 }}
            className="text-5xl md:text-6xl font-semibold tracking-tight leading-[1.05] text-slate-900"
          >
            Designing High-Performance
            <br />
            <span className="text-blue-600">
              Scalable Backend Systems
            </span>
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4 }}
            className="text-lg leading-relaxed text-slate-600 max-w-xl"
          >
            I architect and build reliable backend infrastructures,
            REST APIs, and database systems engineered for scale,
            efficiency, and long-term maintainability.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5 }}
            className="flex flex-wrap gap-6 pt-4"
          >
            {/* Primary CTA */}
            <Link
              to="/contact"
              className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-full font-medium transition duration-300 hover:-translate-y-1 hover:shadow-lg hover:shadow-blue-500/30"
            >
              Start a Conversation →
            </Link>

            {/* Secondary CTA */}
            <Link
              to="/projects"
              className="text-slate-700 px-8 py-4 rounded-full border border-slate-300 bg-white/70 backdrop-blur-sm hover:border-blue-500/40 hover:bg-blue-50/40 transition duration-300"
            >
              View Selected Work
            </Link>
          </motion.div>
        </motion.div>

        {/* RIGHT IMAGE */}
        <motion.div
          initial={{ opacity: 0, y: 60 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: "easeOut", delay: 0.3 }}
          className="relative"
        >
          <motion.div
            animate={{ y: [0, -8, 0] }}
            transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
            className="bg-white/90 backdrop-blur-sm rounded-2xl border border-white/60 shadow-xl shadow-blue-100/40 overflow-hidden"
          >
            <img
              src={heroMockup}
              alt="Backend System Preview"
              className="w-full object-cover"
            />
          </motion.div>
        </motion.div>

      </div>
    </section>
  );
}